/**
 * Convierte un color HEX a RGB
 * @param {string} hex - Color en formato HEX (#RRGGBB)
 * @returns {Object} - Objeto con valores r, g, b
 */
export const hexToRgb = (hex) => {
  // Eliminar el # si existe
  hex = hex.replace('#', '');

  // Convertir a RGB
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);

  return { r, g, b };
};

/**
 * Convierte un color vibrante a un tono pastel suave
 * Mezcla el color original con blanco para hacerlo más pastel
 * @param {string} hex - Color en formato HEX (#RRGGBB)
 * @param {number} opacity - Opacidad para el background (0-1)
 * @returns {Object} - Objeto con backgroundColor y color
 */
export const toPastelColor = (hex, opacity = 0.12) => {
  if (!hex || hex === '#000000') {
    // Color por defecto si no hay color definido
    return {
      backgroundColor: 'rgba(139, 92, 246, 0.1)',
      color: '#8b5cf6'
    };
  }

  const rgb = hexToRgb(hex);

  // Crear versión más oscura y saturada para el texto (más visible)
  // Reducimos los valores RGB para oscurecer el color
  const textR = Math.round(rgb.r * 0.65);
  const textG = Math.round(rgb.g * 0.65);
  const textB = Math.round(rgb.b * 0.65);

  return {
    backgroundColor: `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${opacity})`,
    color: `rgb(${textR}, ${textG}, ${textB})`
  };
};

/**
 * Obtiene el color de una épica desde el store
 * @param {string} epicName - Nombre de la épica
 * @param {Array} epics - Array de épicas del store
 * @returns {Object} - Objeto con backgroundColor y color
 */
export const getEpicColor = (epicName, epics = []) => {
  if (!epicName || !epics || epics.length === 0) {
    return toPastelColor(null);
  }

  const epic = epics.find(e => e.nombre === epicName);

  if (!epic || !epic.color) {
    return toPastelColor(null);
  }

  return toPastelColor(epic.color);
};
